import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";
import { useState } from "react";
import { useQuery } from "shared/hooks/useApi";
import { INSURANCE_PLANS } from "utils/api/graphql/queries/insurance-plans";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { getMinDeltaStart } from "utils/helpers/array";
import { buildDepartmentSkills } from "utils/helpers/address";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const AdherentBirthDate = ({
  project,
  onNext,
  onBack,
  currentStatus,
  tracer,
  territorial = false,
}) => {
  const [deltaStart, setDeltaStart] = useState(1);
  useQuery(INSURANCE_PLANS, {
    variables: { where: {} },
    onCompleted: ({ insurancePlans: { data: insurancePlans } }) => {
      const deltaStart = getMinDeltaStart({
        insurancePlans,
        minValue: 1,
        key: "DELTA_START",
      });
      setDeltaStart(deltaStart);
    },
  });

  const onSubmit = ({
    birthDate,
    socialRegime,
    issuanceDate,
    telecoms,
    optMadelin,
  }) => {
    const zipCode = get(
      telecoms,
      `${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
      null,
    );
    const updatedTelecoms = map(telecoms, (item, key) =>
      defaults(
        { ...item, value: item?.value != null ? String(item.value) : null },
        { id: cuid(), system: key },
      ),
    );
    const fields = get(project, "fields", {});
    const skills = buildDepartmentSkills(get(fields, "skills", {}), zipCode);
    return onNext({
      payload: {
        contact: {
          id: get(project, "contact.id") || cuid(),
          socialRegime,
          optMadelin: optMadelin || false,
          user: {
            id: get(project, "contact.user.id") || cuid(),
            birthDate,
          },
          telecoms: updatedTelecoms,
        },
        contract: {
          id: get(project, "contract.id") || cuid(),
          issuanceDate,
        },
        fields: {
          ...fields,
          skills,
        },
      },
    });
  };

  const telecomsObject = defaults(
    keyBy(get(project, "contact.telecoms", []), "system"),
    {
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null },
    },
  );

  return (
    <>
      <Navbar project={project} progress={currentStatus?.progress} />
      <View
        contact={get(project, "contact", {})}
        contract={get(project, "contract", {})}
        telecoms={telecomsObject}
        onNext={onSubmit}
        onBack={onBack}
        tracer={tracer}
        deltaStart={deltaStart}
        territorial={territorial}
      />
    </>
  );
};

export default AdherentBirthDate;
